'use client';

import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useProgressStore } from './useProgressStore';

export const useNextRouterProgress = () => {
  const router = useRouter();
  const { isAnimating, setIsAnimating } = useProgressStore((state) => ({
    isAnimating: state.isAnimating,
    setIsAnimating: state.setIsAnimating,
  }));

  useEffect(() => {
    const handleStart = () => {
      setIsAnimating(true);
    };
    const handleStop = () => {
      setIsAnimating(false);
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);

  return { isAnimating };
};
